export default "__VITE_ASSET__0Rbz3_WF__";